// Get Active Parameter Configurations
export const getActiveParameterConfigurationsEndpoint = "api/afc/Forecast/parameterConfiguration/getActiveParameterConfigurations";
// Global Param Filter List
export const getGlobalParamFilterListEndpoint = "api/afc/Forecast/Summary/getGlobalParamFilterList";
// Delete Parameter Configuration
export const deleteParameterConfiguration = "api/afc/Forecast/parameterConfiguration/deleteParameterConfiguration";
// Update Parameter Configuration
export const updateParameterConfiguration = "api/afc/Forecast/parameterConfiguration/updateParameterConfiguration";
export const ltVariantsEndpoint="api/user/variants/lt";

// User Variant Management APIs
export const saveVariantEndpoint = "api/user/variants/saveVariant";
export const viewUserVariantEndpoint = "api/user/variants/viewUserVariant";
export const editUserVariantEndpoint = "api/user/variants/editUserVariant";
export const deleteUserVariantEndpoint = "api/user/variants/deleteUserVariant";
export const shareVariantEndpoint = "api/user/variants/shareVariant/share";
export const shareVariantUsersEndpoint = "api/user/variants/shareVariant/share/users";

export const getAfcFilters="api/afc/Forecast/Summary/getSummaryFilterList";
export const getAfcSummary="api/afc/Forecast/Summary/getAFCAnalysisSummary";
export const getAfcRiskCount = "api/afc/Forecast/Summary/getRiskCount";
export const saveAuditHistory = "api/afc/saveAuditHistory";
export const getSupplierSummary = "api/supplier/summary";
export const getSupplyDrilldown = "api/afc/Forecast/Summary/getSupplyDrilldown";

// Purchase Requisition (PR) lookup
export const getPurchaseRequisition = "api/afc/Forecast/Summary/getPurchaseRequisition";
// AFC Analysis (52-week deep dive)
export const getAfcAnalysis = "api/afc/analysis/plant-material-summary";

// Parameter Configuration
export const saveParameterConfiguration = "api/afc/Forecast/parameterConfiguration/saveParameterConfiguration";
// Parameter Configuration Override (save per-row override)
export const saveParameterConfigurationOverride = "api/parameter_configuration_override/save";
// Update global risk configuration
export const updateRiskConfig = "api/afc/risk-config";
// Get active global risk configuration
export const getActiveGlobalRiskConfigEndpoint = "api/afc/getActiveGobalConfig";

// Supplier confirmation (Send to IBP)
export const postSupplierConfirmed = "api/forecast/supplier-confirmed";

// SAP IBP sync status
export const postSapIbpSyncStatus = "api/sap-ibp/sync-status";

// User support ticket
export const postUserSupportTicket = "api/afc/ticket/userSupport";
export const getUserSupportTicketByUser = "api/afc/ticket/userSupport";


